import styled from "styled-components/macro";
import { COLORES } from "../../constants";

export const Container = styled.div`
  font-size: 0.8rem;
  padding: 1rem;
  background-color: ${COLORES.BACKGROUND};
  button {
    cursor: pointer;
  }
  .btn-group-sm {
    margin-top: 10px;
  }

  button.mr-3 {
    margin-right: 3px;
  }

  select.selectPage {
    width: 8rem;
  }

  input.numberPage {
    width: 4rem;
  }
`;

export const TableContainer = styled.div`
  max-height: 58vh;
  overflow: auto;
  .table {
    thead {
      z-index: 1;
    }
  }

  table {
    border: solid 1px black;
    white-space: nowrap;

    tr {
      border: thin solid lightgray;
    }

    th {
      background-color: #f6f6f6;
      cursor: pointer;
      vertical-align: top;
      border: thin solid lightgray;
    }

    td {
      max-width: 40rem;
      overflow-x: hidden;
      text-overflow: ellipsis;
    }

    td.withOnClick {
      cursor: pointer;

      svg {
        height: 1rem;
        margin-right: 0.4rem;
      }
    }

    svg {
      color: black;
    }
  }
`;
